//components/ThemedLogo.tsx
'use client';

interface ThemedLogoProps {
  className?: string;
  alt?: string;
  variant?: 'full' | 'symbol';
}

export default function ThemedLogo({
  className = 'h-14 w-auto',
  alt = 'SigalMark Logo',
  variant = 'full',
}: ThemedLogoProps) {
  const logoSrc =
    variant === 'symbol'
      ? '/logo__theme_standard.png'
      : '/logo_with_text__theme_standard.png';

  return (
    <div
      role="img"
      aria-label={alt}
      className={className}
      style={{
        backgroundColor: 'var(--logo-tint)',
        WebkitMaskImage: `url(${logoSrc})`,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: `url(${logoSrc})`,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        display: 'inline-block', // 👈 essential to make Tailwind size classes apply
        aspectRatio: variant === 'symbol' ? '1 / 1' : 'auto 5 / 1', // 👈 optional: keep logo shape
      }}
    />
  );
}
